import { StymptomsProps } from '../../../interfaces/props/SaudeBemEstar/MeuDiario/StymptomsProps';
import MyDiaryQuestion from './MyDiaryQuestion';
import './styles.css'
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { sxButton } from './sxProps';
import { MeuDiarioTipoQuestEnum } from '../../../interfaces/enum/MeuDiarioTipoQuestEnum';
import { useState } from 'react';
import { MeuDiarioQuestoes } from '../../../interfaces/entities/UnimedAcolhe/MeuDiarioQuestoes';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import ModalActionResponsive from '../../../components/ModalActionResponsive';

function Symptoms(props: StymptomsProps) {
    const [answered, setAnswered] = useState<boolean>(false);
    const accessibility = useAccessibility();
    const navigate = useNavigate(); 

    const [modalAction, setModalAction] = useState<null | {
        handleShowModal?: () => void; textOutlinedButton: string; textContainedButton: string;
        title: string; subTitle?: string; handleOutlinedButton?: () => void; handleContainedButton?: () => void; icon: "error" | "success" | "warning"
    }>(null);


    const handleBack = () => {
        navigate("/saudeBemEstar/unimedAcolhe/inicio", { replace: true });
        props.handleStymptomsBack();
    }

    const openModalDeleteAnexo = () => {
        setModalAction({
            title: 'Atenção!',
            subTitle: 'Ao confirmar, você volta para a tela anterior e desiste do registro atual. Deseja desistir?',
            textOutlinedButton: 'Cancelar',
            textContainedButton: 'Desistir',
            handleContainedButton: handleBack,
            handleOutlinedButton: handleCloseModalAction,
            handleShowModal: handleCloseModalAction,
            icon: 'warning'
        })
    }

    const handleCloseModalAction = () => {
        setModalAction(null);
    }

    const handleAnswer = (answer: string, questionIndex: number, optionIndex: number) => {
        var question = props.questions[questionIndex];
        if(question.codTipoQuestaoTeleOrient === MeuDiarioTipoQuestEnum.radio){
            question.resposta = answer;
            question.lstQuestoesTriagem[optionIndex].resposta = answer;
        }
        else if(question.codTipoQuestaoTeleOrient === MeuDiarioTipoQuestEnum.text){
            question.resposta = answer;
            question.lstQuestoesTriagem[0].resposta = answer;
        }
        else{
            question.lstQuestoesTriagem[optionIndex].resposta = answer;
            if(answer === 'N'){
                const notAnswered = question.lstQuestoesTriagem.some(obj => obj.resposta === "S");
                if(!notAnswered){
                    question.resposta = "";
                }
            }
            else {
                question.resposta = "S";
            }
        }
        var newQuestions = props.questions;
        newQuestions[questionIndex] = question;
        validateAnswers(newQuestions);
        props.handleStymptomsAnswer(question, questionIndex);
    }

    const validateAnswers = (questions: MeuDiarioQuestoes[]) => {

        const notAnswered = questions.some(question => question.codTipoQuestaoTeleOrient !== MeuDiarioTipoQuestEnum.text && question.resposta === "");
        if(!notAnswered){
            setAnswered(true);
        }
        else {
            setAnswered(false);
        }
    }

    return (
        <div className="my-diary-holder">
            {props.questions.map((question, index) => {
                return(
                    <MyDiaryQuestion question={question} index={index} handleAnswer={handleAnswer} disabled={false}/>
                )
            })}
            <div className="start-registration-button">
                <Button
                    variant="contained"
                    size="large"
                    onClick={props.handleSymptoms}
                    sx={sxButton}
                    style={{...accessibility.buttonStyleAccessibility, ...accessibility.buttonTextStyleAccessibility}}
                    fullWidth
                    disabled={!answered}>
                    REGISTRAR
                </Button>
            </div>
            <VoltarButton onClick={openModalDeleteAnexo} />
            <ModalActionResponsive
                showModal={!!modalAction}
                handleShowModal={modalAction?.handleShowModal}
                icon={modalAction?.icon}
                textOutlinedButton={modalAction?.textOutlinedButton || ''}
                textContainedButton={modalAction?.textContainedButton || ''}
                title={modalAction?.title || ''}
                subTitle={modalAction?.subTitle || ''}
                handleOutlinedButton={modalAction?.handleOutlinedButton}
                handleContainedButton={modalAction?.handleContainedButton}
            />
        </div>
    )
}

export default Symptoms;